import styled from 'styled-components';

export const ROBOTO = "'Roboto', Helvetica, Arial, sans-serif";

// The banner surface itself, tinted with the selected banner type color, per
// the Quartz 3.0 Feedback tokens (see `BANNER_TYPE_PREVIEW_COLORS`).
export const BannerFrame = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 8px 16px;
    border: 1px solid ${({ color }) => color};
    border-radius: 8px;
    background: ${({ backgroundColor }) => backgroundColor};
    box-sizing: border-box;
    overflow: hidden;
`;

export const BannerMessage = styled.div`
    flex: 1;
    min-width: 0;
    color: ${({ color }) => color};
    font-family: ${ROBOTO};
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    overflow-wrap: anywhere;
    word-break: break-word;

    p {
        margin: 0;
    }
`;

export const BannerCloseButton = styled.button`
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    padding: 0;
    border: none;
    background: none;
    color: ${({ color }) => color};
    cursor: pointer;
    outline: none;

    &:focus,
    &:focus-visible {
        outline: none;
    }
`;

// Stacks multiple banners with consistent spacing, so callers don't have to
// re-implement the gap between banners themselves.
export const BannerPreviewList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
`;
